import { ItemCardList, RightSideModal, RightSideModalTitle, Spinner } from 'components';
import * as c from 'models/constants';
import * as React from 'react';
import { IStore } from 'redux/IStore';
import { Dispatch, connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { InjectedManualBookingModalProps, ManualBookingScreen } from '..';
import { translate } from 'react-i18next';
import { BookingInputField } from 'components/FormControls';
import { Field } from 'redux-form';
import renderIcon from 'helpers/renderIcon';
import {
	filterShopCustomers,
	getOneShopCustomer,
	getShopCustomers,
	resetShopCustomersRequest,
} from 'redux/modules/shop/shopcard';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IManualBookingFormData } from 'models/shop/manualbooking';
require('./style.scss');

interface IOwnProps extends InjectedManualBookingModalProps {}

interface IState {
	customerSearchCurrent?: string;
	customerSearch?: string;
}

type IProps = IOwnProps &
	ReturnType<typeof stateToProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps;

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SelectCustomerScreenComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.onSubmitSearchForm = this.onSubmitSearchForm.bind(this);

		this.state = {};
	}
	componentDidMount(): void {
		this.props.getShopCustomers(1, true);
	}

	private loadMoreData() {
		return this.props.getShopCustomers(this.props.customers.currentPage + 1);
	}

	private onSubmitSearchForm(form?: any) {
		form?.preventDefault();

		this.setState({ customerSearch: !!this.state.customerSearchCurrent?.length && this.state.customerSearchCurrent });
		this.props.getShopCustomers(1, true, this.state.customerSearchCurrent);
	}

	componentWillUnmount(): void {
		// Reset so new data gets fetched when returning
		this.props.resetShopCustomersRequest();
		this.props.change('customerSearch', '');
	}

	public render() {
		const { t, startCloseModal, closeModal, customers } = this.props;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: customers.items?.length,
			next: this.loadMoreData,
			hasMore: customers.currentPage < customers.totalPages,
			loader: (
				<>
					<Spinner />
				</>
			),
		};
		return (
			<RightSideModal
				modalClass="select-customer-screen"
				size="small"
				header={
					<>
						<RightSideModalTitle
							title={t('ManualBookingModal_BookingCustomer_SelectCustomer_Title')}
							backButtonClick={() => this.props.setScreen(ManualBookingScreen.Main)}
							closeModalClick={
								(this.props.mode === 'add' && !this.props.dirty) ||
								(this.props?.mode === 'edit' && !this.props?.currentFormValues?.isEditModeEnabled)
									? closeModal
									: startCloseModal
							}
						/>
						<form className="select-customer-screen__header__search-container" onSubmit={this.onSubmitSearchForm}>
							<Field
								name="customerSearch"
								component={BookingInputField}
								placeholder={t('ManualBookingModal_BookingCustomer_SelectCustomer_SearchPlaceholder')}
								className="select-customer-screen__header__search-container__search-field"
								customIconName="search_gray"
								onChangeAction={(e) => {
									this.setState({ customerSearchCurrent: e.target.value });
								}}
								iconInside
								functionToTriggerOnSearch={() => this.onSubmitSearchForm()}
							/>
							{renderIcon(
								'plus_user',
								undefined,
								undefined,
								'select-customer-screen__header__search-container__add-icon',
								() => {
									this.props.setScreen(ManualBookingScreen.AddEditCustomer, {
										previousScreen: ManualBookingScreen.SelectCustomer,
									});
								},
							)}
						</form>
					</>
				}
			>
				{!this.state?.customerSearch && (
					<div
						className="select-customer-screen__mobile-add-new-customer"
						onClick={() => {
							this.props.setScreen(ManualBookingScreen.AddEditCustomer, {
								previousScreen: ManualBookingScreen.SelectCustomer,
							});
						}}
					>
						<div className="select-customer-screen__mobile-add-new-customer__icon-wrapper">
							{renderIcon('plus_user', 24, 24)}
						</div>
						<div className="select-customer-screen__mobile-add-new-customer__text">
							{t('ManualBookingModal_BookingCustomer_SelectCustomer_AddNewClient')}
						</div>
					</div>
				)}
				<div className="select-customer-screen__customer-list">
					<ItemCardList
						items={customers?.items}
						itemType={c.NODE_TYPE_CUSTOMER_ITEM_CARD}
						isInfiniteScroll={true}
						infiniteScrollProps={infiniteScrollProps}
						noResults={
							<div className="select-customer-screen__customer-list__no-results">
								{renderIcon(
									'search_not_found',
									undefined,
									undefined,
									'select-customer-screen__customer-list__no-results__icon',
								)}
								<h3 className="select-customer-screen__customer-list__no-results__title">
									{t('ManualBookingModal_BookingCustomer_SelectCustomer_NoResults_Title')}
								</h3>
								<h4 className="select-customer-screen__customer-list__no-results__subtitle">
									{t('ManualBookingModal_BookingCustomer_SelectCustomer_NoResults_Subtitle_1')}{' '}
									<span
										className="select-customer-screen__customer-list__no-results__subtitle__button"
										onClick={() => {
											this.props.setScreen(ManualBookingScreen.AddEditCustomer, {
												previousScreen: ManualBookingScreen.SelectCustomer,
											});
										}}
									>
										{t('ManualBookingModal_BookingCustomer_SelectCustomer_NoResults_Subtitle_2')}
									</span>
								</h4>
							</div>
						}
						useIntersectionObserver={true}
						goToCard={(customerId) => {
							this.props.change('customerId', customerId);
							this.props.getOneShopCustomer(customerId);
							this.props.setScreen(ManualBookingScreen.Main);
						}}
					/>
				</div>
			</RightSideModal>
		);
	}
}

const dispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	// Elastic search gets result only when atleast 3 characters in keyword
	getShopCustomers: (currentPage?: number, clean?: boolean, keyword?: string) =>
		keyword
			? keyword.length >= 3
				? dispatch(filterShopCustomers(keyword, ownProps.shopId, currentPage, clean))
				: null
			: dispatch(getShopCustomers(ownProps.shopId, currentPage, clean, keyword)),
	getOneShopCustomer: (customerId) => dispatch(getOneShopCustomer(customerId)),
	resetShopCustomersRequest: () => dispatch(resetShopCustomersRequest()),
});

const stateToProps = (state: IStore) => {
	let currentFormValues: IManualBookingFormData = null;
	if (state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN] && state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values) {
		currentFormValues = state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values;
	}

	return {
		customers: state.shopcard.customers,
		currentFormValues,
	};
};

export const SelectCustomerScreen = connect(
	stateToProps,
	dispatchToProps,
)(
	reduxForm({
		form: c.FORM_NAME_MANUAL_BOOKING_PLAN,
		enableReinitialize: false,
		destroyOnUnmount: false,
	})(SelectCustomerScreenComponent),
);
